import colors from './colors'
import fonts from './fonts'


export default {
  html: {
    fontSize: '62.5%',
  },
  'body, html': {
    height: '100%',
  },
  body: {
    padding: 0,
    margin: 0,
    background: colors.pureBlack,
    color: colors.pureWhite,
    ...fonts.UniversRoman,
    'html[lang=kr] &': {
      ...fonts.YDGothic,
    },
    'html[lang=jp] &': {
      ...fonts.TazuganeGothic,
    },
    'html[lang=cn] &': {
      ...fonts.MYingHei,
    },
    MozOsxFontSmoothing: 'grayscale',
    WebkitFontSmoothing: 'antialiased',
  },
  '#___gatsby, #gatsby-focus-wrapper': {
    height: '100%',
  },
  p: {
    margin: 0,
    padding: 0,
  },
  a: {
    textDecoration: 'none',
    cursor: 'pointer',
    '&:hover': {
      textDecoration: 'none',
    },
  },
  img: {
    maxWidth: '100%',
    height: 'auto',
    verticalAlign: 'middle',
  },
  'input, select, textarea, button': {
    '&:focus:not([keyboard-focus])': {
      outlineWidth: 0,
    },
  },
  'input::-ms-clear': {
    display: 'none',
  },
  '*': {
    boxSizing: 'border-box',
    '&:before, &:after': {
      boxSizing: 'border-box',
    },
  },
  button: {
    padding: 0,
    border: 0,
  },
}
